var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _vm.ruleStats
        ? _c(
            "el-row",
            { staticStyle: { "margin-bottom": "20px" }, attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "stat-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("rules.totalEvaluations"))),
                      ]),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumber(
                              _vm.ruleStats.summary.totalEvaluations
                            )
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v(_vm._s(_vm.$t("rules.last30Days"))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "stat-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("rules.matchRate"))),
                      ]),
                      _c("div", { staticClass: "stat-value stat-success" }, [
                        _vm._v(_vm._s(_vm.ruleStats.summary.matchRate) + "%"),
                      ]),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v(
                          _vm._s(_vm.ruleStats.summary.totalMatched) +
                            " / " +
                            _vm._s(_vm.ruleStats.summary.totalEvaluations)
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "stat-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("rules.featuresGranted"))),
                      ]),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumber(_vm.ruleStats.summary.totalGrants)
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v(
                          _vm._s(_vm.ruleStats.summary.avgDurationMs) + "ms avg"
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "stat-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("rules.errors"))),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "stat-value",
                          class:
                            _vm.ruleStats.summary.totalErrors > 0
                              ? "stat-warning"
                              : "",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatNumber(
                                  _vm.ruleStats.summary.totalErrors
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "stat-sub" }, [
                        _vm._v(_vm._s(_vm.$t("rules.last30Days"))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: { placeholder: "Trigger Type", clearable: "" },
              on: { change: _vm.loadRules },
              model: {
                value: _vm.triggerTypeFilter,
                callback: function ($$v) {
                  _vm.triggerTypeFilter = $$v
                },
                expression: "triggerTypeFilter",
              },
            },
            [
              _c("el-option", { attrs: { label: "All", value: "" } }),
              _c("el-option", {
                attrs: {
                  label: "Device Connection",
                  value: "device_connection",
                },
              }),
              _c("el-option", {
                attrs: {
                  label: "Subscription Purchase",
                  value: "subscription_purchase",
                },
              }),
              _c("el-option", {
                attrs: {
                  label: "App Store Purchase",
                  value: "app_store_purchase",
                },
              }),
              _c("el-option", {
                attrs: {
                  label: "Google Play Purchase",
                  value: "google_play_purchase",
                },
              }),
              _c("el-option", {
                attrs: { label: "Zoho Purchase", value: "zoho_purchase" },
              }),
              _c("el-option", {
                attrs: { label: "Admin Grant", value: "admin_grant" },
              }),
              _c("el-option", {
                attrs: {
                  label: "Coupon Redemption",
                  value: "coupon_redemption",
                },
              }),
              _c("el-option", { attrs: { label: "Manual", value: "manual" } }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.loadRules },
            },
            [_vm._v(" Search ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v(" Create Rule ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.rules,
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", align: "center", width: "60" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.id) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Rule Name", align: "center", width: "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("strong", [_vm._v(_vm._s(row.ruleName))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Trigger Type", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getTriggerTypeTag(row.triggerType),
                          size: "small",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.triggerType) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Priority", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getPriorityTag(row.priority),
                          size: "small",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.priority) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Active", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleActive(row)
                        },
                      },
                      model: {
                        value: row.isActive,
                        callback: function ($$v) {
                          _vm.$set(row, "isActive", $$v)
                        },
                        expression: "row.isActive",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Description",
              align: "center",
              "min-width": "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.description || "N/A") + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              align: "center",
              width: "300",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-view",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(row)
                          },
                        },
                      },
                      [_vm._v(" View ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "warning",
                          icon: "el-icon-edit",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v(" Edit ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "info",
                          icon: "el-icon-data-analysis",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleTest(row)
                          },
                        },
                      },
                      [_vm._v(" Test ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "danger",
                          icon: "el-icon-delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(row)
                          },
                        },
                      },
                      [_vm._v(" Delete ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-collapse",
        { staticStyle: { "margin-top": "30px" } },
        [
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: _vm.$t("rules.executionHistory"),
                name: "executionHistory",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "filter-container",
                  staticStyle: { "margin-bottom": "15px" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "200px" },
                      attrs: {
                        placeholder: _vm.$t("rules.filterByRule"),
                        clearable: "",
                      },
                      on: { change: _vm.loadExecutionHistory },
                      model: {
                        value: _vm.historyFilter.ruleId,
                        callback: function ($$v) {
                          _vm.$set(_vm.historyFilter, "ruleId", $$v)
                        },
                        expression: "historyFilter.ruleId",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: _vm.$t("rules.allRules"), value: "" },
                      }),
                      _vm._l(_vm.rules, function (rule) {
                        return _c("el-option", {
                          key: rule.id,
                          attrs: { label: rule.ruleName, value: rule.id },
                        })
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "160px" },
                      attrs: {
                        placeholder: _vm.$t("rules.filterByMatch"),
                        clearable: "",
                      },
                      on: { change: _vm.loadExecutionHistory },
                      model: {
                        value: _vm.historyFilter.matched,
                        callback: function ($$v) {
                          _vm.$set(_vm.historyFilter, "matched", $$v)
                        },
                        expression: "historyFilter.matched",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "All", value: "" } }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("rules.matchedOnly"),
                          value: "true",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("rules.unmatchedOnly"),
                          value: "false",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        size: "small",
                      },
                      on: { click: _vm.loadExecutionHistory },
                    },
                    [_vm._v(" Search ")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.historyLoading,
                      expression: "historyLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.executionHistory,
                    border: "",
                    fit: "",
                    size: "small",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "expand" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              { staticStyle: { padding: "10px 20px" } },
                              [
                                row.conditionsContext
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("rules.conditionsContext")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c(
                                          "pre",
                                          { staticClass: "json-display" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                JSON.stringify(
                                                  row.conditionsContext,
                                                  null,
                                                  2
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                row.featuresGranted
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("rules.grantedFeatures")
                                            ) + ":"
                                          ),
                                        ]),
                                        _c(
                                          "pre",
                                          { staticClass: "json-display" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                JSON.stringify(
                                                  row.featuresGranted,
                                                  null,
                                                  2
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                row.errorMessage
                                  ? _c(
                                      "div",
                                      { staticStyle: { color: "#F56C6C" } },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("rules.errorMessage")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " + _vm._s(row.errorMessage) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                row.sourceReference
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-top": "5px",
                                          color: "#909399",
                                        },
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("rules.sourceReference")
                                            ) + ":"
                                          ),
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(row.sourceReference) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("rules.date"), width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(_vm._s(_vm.formatDate(row.created_at))),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("rules.ruleName"), width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(_vm._s(row.ruleName))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("rules.triggerType"),
                      width: "160",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getTriggerTypeTag(row.triggerType),
                                  size: "mini",
                                },
                              },
                              [_vm._v(" " + _vm._s(row.triggerType) + " ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("rules.matched"),
                      width: "90",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: row.matched ? "success" : "info",
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(row.matched ? "Yes" : "No") + " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("rules.user"), width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_vm._v(" " + _vm._s(row.userId || "-") + " ")]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("rules.duration"),
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.executionDurationMs != null
                                    ? row.executionDurationMs + "ms"
                                    : "-"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.historyPagination.total > 0
                ? _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "15px",
                      "text-align": "right",
                    },
                    attrs: {
                      background: "",
                      layout: "prev, pager, next, total",
                      "current-page": _vm.historyPagination.page,
                      "page-size": _vm.historyPagination.limit,
                      total: _vm.historyPagination.total,
                    },
                    on: { "current-change": _vm.handleHistoryPageChange },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogStatus === "create" ? "Create Rule" : "Edit Rule",
            visible: _vm.dialogFormVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Rule Name", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Enter rule name" },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "Rule description",
                    },
                    model: {
                      value: _vm.formData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "description", $$v)
                      },
                      expression: "formData.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Trigger Type", prop: "triggerType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Select trigger" },
                      model: {
                        value: _vm.formData.triggerType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "triggerType", $$v)
                        },
                        expression: "formData.triggerType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "Device Connection",
                          value: "device_connection",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Subscription Purchase",
                          value: "subscription_purchase",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "App Store Purchase",
                          value: "app_store_purchase",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Google Play Purchase",
                          value: "google_play_purchase",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Zoho Purchase",
                          value: "zoho_purchase",
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: "Admin Grant", value: "admin_grant" },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Coupon Redemption",
                          value: "coupon_redemption",
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: "Manual", value: "manual" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Priority", prop: "priority" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, max: 1000 },
                    model: {
                      value: _vm.formData.priority,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "priority", $$v)
                      },
                      expression: "formData.priority",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: { "margin-left": "10px", color: "#909399" },
                    },
                    [_vm._v("Lower number = Higher priority")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Active" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.formData.isActive,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "isActive", $$v)
                      },
                      expression: "formData.isActive",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Valid From" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              placeholder: "No start limit",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.validFrom,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "validFrom", $$v)
                              },
                              expression: "formData.validFrom",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Valid Until" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetime",
                              placeholder: "No end limit",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.validUntil,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "validUntil", $$v)
                              },
                              expression: "formData.validUntil",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Conditions"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Product Type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: "Any product type",
                      },
                      model: {
                        value: _vm.formData.conditions.product_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData.conditions, "product_type", $$v)
                        },
                        expression: "formData.conditions.product_type",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "V1", value: "V1" } }),
                      _c("el-option", { attrs: { label: "V2", value: "V2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Purchase Type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: "Any purchase type",
                      },
                      model: {
                        value: _vm.formData.conditions.purchase_type,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.formData.conditions,
                            "purchase_type",
                            $$v
                          )
                        },
                        expression: "formData.conditions.purchase_type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Pre-order", value: "PRE_ORDER" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Regular", value: "REGULAR" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Distributor", value: "DISTRIBUTOR" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Other", value: "OTHER" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "User Country" } },
                [
                  _c("el-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      multiple: "",
                      filterable: "",
                      "allow-create": "",
                      clearable: "",
                      placeholder: "Any country",
                    },
                    model: {
                      value: _vm.formData.conditions.user_country,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.conditions, "user_country", $$v)
                      },
                      expression: "formData.conditions.user_country",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "User Segment" } },
                [
                  _c("el-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      multiple: "",
                      filterable: "",
                      "allow-create": "",
                      clearable: "",
                      placeholder: "Any segment",
                    },
                    model: {
                      value: _vm.formData.conditions.user_segment,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.conditions, "user_segment", $$v)
                      },
                      expression: "formData.conditions.user_segment",
                    },
                  }),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Feature Grants"),
              ]),
              _vm._l(_vm.formData.featureGrants, function (grant, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticStyle: {
                      border: "1px solid #EBEEF5",
                      padding: "15px",
                      "margin-bottom": "10px",
                      "border-radius": "4px",
                    },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  label: "Feature",
                                  "label-width": "60px",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { placeholder: "Select feature" },
                                    model: {
                                      value: grant.feature_key,
                                      callback: function ($$v) {
                                        _vm.$set(grant, "feature_key", $$v)
                                      },
                                      expression: "grant.feature_key",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "Voice Assistant",
                                        value: "voice_assistant",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Smart Map",
                                        value: "smart_map",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "WeAssist",
                                        value: "weassist",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Navigation Plus",
                                        value: "navigation_plus",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Referral Bonus",
                                        value: "referral_bonus",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Free Trial",
                                        value: "free_trial",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Smart Cane Basic",
                                        value: "cane_basic",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  label: "Duration",
                                  "label-width": "65px",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { placeholder: "Type" },
                                    model: {
                                      value: grant.duration_type,
                                      callback: function ($$v) {
                                        _vm.$set(grant, "duration_type", $$v)
                                      },
                                      expression: "grant.duration_type",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "Permanent",
                                        value: "permanent",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "Days", value: "days" },
                                    }),
                                    _c("el-option", {
                                      attrs: {
                                        label: "Months",
                                        value: "months",
                                      },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "Years", value: "years" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        grant.duration_type &&
                        grant.duration_type !== "permanent"
                          ? _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: {
                                      label: "Value",
                                      "label-width": "45px",
                                    },
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "100%" },
                                      attrs: { min: 1, max: 999 },
                                      model: {
                                        value: grant.duration_value,
                                        callback: function ($$v) {
                                          _vm.$set(grant, "duration_value", $$v)
                                        },
                                        expression: "grant.duration_value",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-col",
                          { attrs: { span: 2 } },
                          [
                            _c("el-button", {
                              staticStyle: { "margin-top": "2px" },
                              attrs: {
                                type: "danger",
                                icon: "el-icon-delete",
                                circle: "",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeFeatureGrant(index)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    plain: "",
                    icon: "el-icon-plus",
                    size: "small",
                  },
                  on: { click: _vm.addFeatureGrant },
                },
                [_vm._v(" Add Feature Grant ")]
              ),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveRule } },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Rule Details",
            visible: _vm.dialogViewVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogViewVisible = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 2, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                _vm._v(_vm._s(_vm.viewData.id)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "Rule Name" } }, [
                _c("strong", [_vm._v(_vm._s(_vm.viewData.ruleName))]),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Rule Key", span: 2 } },
                [_vm._v(_vm._s(_vm.viewData.ruleKey))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Trigger Type" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getTriggerTypeTag(_vm.viewData.triggerType),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.viewData.triggerType) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Priority" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getPriorityTag(_vm.viewData.priority),
                      },
                    },
                    [_vm._v(_vm._s(_vm.viewData.priority))]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Active" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.viewData.isActive ? "success" : "danger",
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.viewData.isActive ? "Yes" : "No") + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "Created By" } }, [
                _vm._v(" " + _vm._s(_vm.viewData.createdBy || "System") + " "),
              ]),
              _c("el-descriptions-item", { attrs: { label: "Valid From" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.viewData.validFrom
                        ? _vm.formatDate(_vm.viewData.validFrom)
                        : "No limit"
                    ) +
                    " "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "Valid Until" } }, [
                _c(
                  "span",
                  {
                    style:
                      _vm.viewData.validUntil &&
                      new Date(_vm.viewData.validUntil) < new Date()
                        ? "color: #F56C6C; font-weight: bold;"
                        : "",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.viewData.validUntil
                            ? _vm.formatDate(_vm.viewData.validUntil)
                            : "No limit"
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Description", span: 2 } },
                [_vm._v(" " + _vm._s(_vm.viewData.description || "N/A") + " ")]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Created At", span: 2 } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.formatDate(_vm.viewData.createdAt)) + " "
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Conditions", span: 2 } },
                [
                  Object.keys(_vm.viewData.conditionsJson || {}).length === 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-tag",
                            { attrs: { type: "info", size: "small" } },
                            [_vm._v("No conditions (applies to all)")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        _vm._l(
                          _vm.viewData.conditionsJson,
                          function (value, key) {
                            return _c(
                              "div",
                              {
                                key: key,
                                staticStyle: { "margin-bottom": "4px" },
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.formatConditionLabel(key)) + ":"
                                  ),
                                ]),
                                !Array.isArray(value)
                                  ? _c(
                                      "el-tag",
                                      {
                                        staticStyle: { "margin-left": "5px" },
                                        attrs: { size: "small" },
                                      },
                                      [_vm._v(_vm._s(value))]
                                    )
                                  : _vm._l(value, function (v) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: v,
                                          staticStyle: { "margin-left": "5px" },
                                          attrs: { size: "small" },
                                        },
                                        [_vm._v(_vm._s(v))]
                                      )
                                    }),
                              ],
                              2
                            )
                          }
                        ),
                        0
                      ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Feature Grants", span: 2 } },
                _vm._l(_vm.viewData.featureGrantsJson, function (grant, i) {
                  return _c(
                    "div",
                    { key: i, staticStyle: { "margin-bottom": "4px" } },
                    [
                      _c(
                        "el-tag",
                        { attrs: { type: "success", size: "small" } },
                        [_vm._v(_vm._s(grant.feature_key))]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "8px",
                            color: "#606266",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.formatDuration(grant)) + " ")]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogViewVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Test Rule",
            visible: _vm.dialogTestVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTestVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              title: "Test the rule with sample context data",
              type: "info",
              closable: false,
            },
          }),
          _c(
            "el-form",
            { attrs: { "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Rule" } },
                [_c("el-tag", [_vm._v(_vm._s(_vm.testData.ruleName))])],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Test Context (JSON)" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 8,
                      placeholder:
                        '{"product_type": "V2", "purchase_type": "PRE_ORDER", "activation_date": "2025-03-15"}',
                    },
                    model: {
                      value: _vm.testContextJson,
                      callback: function ($$v) {
                        _vm.testContextJson = $$v
                      },
                      expression: "testContextJson",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider", [_vm._v("Test Result")]),
          _vm.testResult
            ? _c(
                "div",
                [
                  _c("el-alert", {
                    staticStyle: { "margin-bottom": "20px" },
                    attrs: {
                      title: _vm.testResult.matched
                        ? "Rule Matched!"
                        : "Rule Did Not Match",
                      type: _vm.testResult.matched ? "success" : "warning",
                      closable: false,
                    },
                  }),
                  _vm.testResult.matched &&
                  _vm.testResult.grants &&
                  _vm.testResult.grants.length > 0
                    ? _c("div", [
                        _c("h4", [_vm._v("Grants that would be applied:")]),
                        _c("pre", { staticClass: "json-display" }, [
                          _vm._v(
                            _vm._s(
                              JSON.stringify(_vm.testResult.grants, null, 2)
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogTestVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.runTest } },
                [_vm._v("Run Test")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }